import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLang, LangToggle } from "../lib/i18n";
import { getLandingContent } from "../lib/landingContent";
import "./TirzepatidePage.css";

export default function TirzepatidePage() {
  const { lang } = useLang();
  const c = getLandingContent(lang, 'tirzepatide');

  useEffect(() => {
    window.scrollTo(0, 0);

    // Scroll reveal animation
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    const reveals = document.querySelectorAll('.reveal');
    reveals.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const openModal = () => {
    window.location.href = "/intake/start?product=tirzepatide";
  };

  return (
    <div className="tirz-page">
      {/* Sticky Bottom Bar */}
      <div className="sticky-bar">
        <div className="sticky-bar-text">
          <strong>Tirzepatide</strong> — {c.stickyBar.text}
        </div>
        <button className="btn-cta" onClick={openModal}>
          {c.stickyBar.cta} <span className="arrow">→</span>
        </button>
      </div>

      {/* Navigation */}
      <nav className="tirz-nav">
        <div className="logo-area">
          <Link to="/">
            <img src="https://assets.cdn.filesafe.space/F6iXsZYsDLnX3HpNjkIU/media/69db664fb30bc52371159e72.png" alt="AntiAging by BB" />
          </Link>
        </div>
        <div className="nav-links">
          <a href="#benefits" className="nav-link">{c.nav.benefits}</a>
          <a href="#how-it-works" className="nav-link">{c.nav.howItWorks}</a>
          <a href="#trust" className="nav-link">{c.nav.whyUs}</a>
          <LangToggle />
          <button className="btn-cta" onClick={openModal} style={{padding:"0.52rem 1.4rem", fontSize:"0.76rem"}}>
            {c.nav.getStarted} <span className="arrow">→</span>
          </button>
        </div>
      </nav>

      {/* Hero */}
      <header className="hero">
        <div>
          <span className="hero-eyebrow">
            <span className="eyebrow-dot"></span>{c.hero.eyebrow}
          </span>
          <h1>{c.hero.h1}<br /><em>{c.hero.h1Em}</em></h1>
          <p className="hero-sub">{c.hero.sub}</p>
          <div className="hero-cta-wrap">
            <button className="btn-cta-lg" onClick={openModal}>
              {c.hero.cta} <span className="arrow">→</span>
            </button>
            <p className="hero-micro">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
              </svg>
              {c.hero.micro}
            </p>
          </div>
          <div className="hero-trust-row">
            {c.hero.trust.map((t, i) => (
              <div key={i} className="htrust">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  {i === 0 && <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>}
                  {i === 1 && <path d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"/>}
                  {i === 2 && <><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></>}
                  {i === 3 && <path d="M5 12h14M12 5l7 7-7 7"/>}
                </svg>
                {t}
              </div>
            ))}
          </div>
        </div>
        <div className="hero-img-col">
          <div className="hero-img-wrap">
            <div className="hero-img-glow"></div>
            <div className="hero-img-ring"></div>
            <img src="https://assets.cdn.filesafe.space/F6iXsZYsDLnX3HpNjkIU/media/69de8718d8d5f6ae837979fa.png" alt="Tirzepatide Injection" />
            <div className="img-badge">{c.hero.badge}</div>
          </div>
        </div>
      </header>

      <div className="divider"></div>

      {/* Benefits Section */}
      <section className="section" id="benefits">
        <div className="section-inner">
          <p className="section-label reveal">{c.benefits.label}</p>
          <h2 className="section-title reveal">{c.benefits.title}<br /><em>{c.benefits.titleEm}</em></h2>
          <p className="section-desc reveal">{c.benefits.subtitle}</p>

          <div className="benefits-layout">
            <div className="benefit-list">
              {c.benefits.items.map((item, i) => (
                <div key={i} className="benefit-item reveal">
                  <div className="bicon">{item.icon}</div>
                  <div className="btext">
                    <strong>{item.title}</strong>
                    <span>{item.desc}</span>
                  </div>
                </div>
              ))}
            </div>
            <div className="stat-orb reveal">
              <div className="orb-num">{c.benefits.statNum}</div>
              <div className="orb-label">{c.benefits.statLabel}</div>
              <div className="orb-sub">{c.benefits.statSub}</div>
            </div>
          </div>

          <div className="s-cta-row reveal">
            <button className="btn-cta" onClick={openModal}>{c.nav.getStarted} <span className="arrow">→</span></button>
            <span className="s-cta-note">{c.benefits.ctaNote}</span>
          </div>
        </div>
      </section>

      <div className="divider"></div>

      {/* Formula Section */}
      <section className="section dark" id="what-is-it">
        <div className="section-inner">
          <p className="section-label reveal">{c.formula.label}</p>
          <h2 className="section-title reveal">{c.formula.title}<br /><em>{c.formula.titleEm}</em></h2>
          <p className="section-desc reveal">{c.formula.subtitle}</p>

          <div className="what-grid">
            <div>
              <div className="info-card reveal" style={{marginBottom:"1.2rem"}}>
                <h4><span>{c.formula.cards[0].icon}</span> {c.formula.cards[0].title}</h4>
                <p>{c.formula.cards[0].desc}</p>
              </div>
              <div className="info-card reveal">
                <h4><span>{c.formula.cards[1].icon}</span> {c.formula.cards[1].title}</h4>
                <table className="dose-table">
                  <thead><tr><th>{lang === 'es' ? 'Formulación' : 'Formulation'}</th><th>{lang === 'es' ? 'Concentración' : 'Concentration'}</th><th>{lang === 'es' ? 'Vial' : 'Vial'}</th></tr></thead>
                  <tbody>
                    {c.formula.cards[1].table.map((row, i) => (
                      <tr key={i}><td>{row[0]}</td><td>{row[1]}</td><td>{row[2]}</td></tr>
                    ))}
                  </tbody>
                </table>
                <p style={{marginTop:"0.8rem", fontSize:"0.76rem"}}>{c.formula.cards[1].tableNote}</p>
              </div>
            </div>
            <div>
              <div className="info-card reveal" style={{marginBottom:"1.2rem"}}>
                <h4><span>{c.formula.cards[2].icon}</span> {c.formula.cards[2].title}</h4>
                <p>{c.formula.cards[2].desc}</p>
              </div>
              <div className="info-card reveal">
                <h4><span>{c.formula.cards[3].icon}</span> {c.formula.cards[3].title}</h4>
                <p>{c.formula.cards[3].desc}</p>
              </div>
            </div>
          </div>

          <div className="s-cta-row reveal" style={{justifyContent:"center", marginTop:"3rem"}}>
            <button className="btn-cta" onClick={openModal}>{c.nav.getStarted} <span className="arrow">→</span></button>
            <span className="s-cta-note">{c.formula.ctaNote}</span>
          </div>
        </div>
      </section>

      <div className="divider"></div>

      {/* How It Works */}
      <section className="section" id="how-it-works">
        <div className="section-inner">
          <p className="section-label reveal">{c.howItWorks.label}</p>
          <h2 className="section-title reveal">{c.howItWorks.title}<br /><em>{c.howItWorks.titleEm}</em></h2>
          <p className="section-desc reveal">{c.howItWorks.subtitle}</p>

          <div className="steps-wrap">
            {c.howItWorks.steps.map((step, i) => (
              <div key={i} className="step-card reveal">
                <div className="step-num">{step.num}</div>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>
            ))}
          </div>

          <div className="how-cta-wrap reveal">
            <button className="btn-cta-lg" onClick={openModal}>{c.nav.getStarted} <span className="arrow">→</span></button>
            <span className="s-cta-note">{c.howItWorks.ctaNote}</span>
          </div>
        </div>
      </section>

      <div className="divider"></div>

      {/* Trust Section */}
      <section className="section dark" id="trust">
        <div className="section-inner">
          <p className="section-label reveal" style={{textAlign:"center"}}>{c.trust.label}</p>
          <h2 className="section-title reveal" style={{textAlign:"center", maxWidth:"560px", marginLeft:"auto", marginRight:"auto"}}>
            {c.trust.title}<br /><em>{c.trust.titleEm}</em>
          </h2>

          <div className="trust-grid">
            {c.trust.items.map((item, i) => (
              <div key={i} className="trust-item reveal">
                <div className="ticon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    {i === 0 && <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>}
                    {i === 1 && <path d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"/>}
                    {i === 2 && <><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></>}
                    {i === 3 && <><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></>}
                  </svg>
                </div>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="s-cta-row reveal" style={{justifyContent:"center", marginTop:"3rem"}}>
            <button className="btn-cta" onClick={openModal}>{c.nav.getStarted} <span className="arrow">→</span></button>
          </div>
        </div>
      </section>

      <div className="divider"></div>

      {/* Final CTA */}
      <section className="final-cta" id="get-started">
        <div className="final-inner">
          <p className="section-label reveal">{c.finalCta.label}</p>
          <h2 className="section-title reveal">{c.finalCta.title}<br /><em>{c.finalCta.titleEm}</em></h2>
          <p className="section-desc reveal">{c.finalCta.subtitle}</p>
          <div className="reveal">
            <button className="btn-cta-lg" onClick={openModal}>{c.nav.getStarted} <span className="arrow">→</span></button>
          </div>
          <div className="final-meta reveal">
            {c.finalCta.meta.map((text, i) => (
              <div key={i} className="meta-item">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  {i === 0 && <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>}
                  {i === 1 && <><path d="M9 12l2 2 4-4"/><path d="M12 2a10 10 0 100 20 10 10 0 000-20z"/></>}
                  {i === 2 && <><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></>}
                  {i === 3 && <path d="M5 12h14M12 5l7 7-7 7"/>}
                </svg>
                {text}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="tirz-footer">
        <div className="footer-inner">
          <div className="footer-logo">
            <img src="https://assets.cdn.filesafe.space/F6iXsZYsDLnX3HpNjkIU/media/69db664fb30bc52371159e72.png" alt="AntiAging by BB" />
          </div>
          <div className="footer-links">
            {c.footer.links.map((link, i) => (
              <a key={i} href={['https://antiagingbybb.com/privacy', 'https://antiagingbybb.com/terms', 'https://antiagingbybb.com/appointments'][i]}>{link}</a>
            ))}
          </div>
          <p className="footer-copy">{c.footer.copy}</p>
        </div>
      </footer>

      <div className="disclaimer">{c.disclaimer}</div>
    </div>
  );
}
